const showAndHidePartFace = (linkSelector, showBlockSelector, linkHideSelector) => {

	let link = document.querySelectorAll(linkSelector),
		showBlock = document.querySelector(showBlockSelector),
		linkHide = document.querySelectorAll(linkHideSelector);

	if (link) {

		function insertHTMLFadeIn() {

			showBlock.classList.remove('hide');
			showBlock.classList.remove('fadeOut');
			showBlock.classList.add('fadeIn');

			link.forEach(function (item, index) {
				item.addEventListener('mouseover',insertHTMLFadeIn);
			});

			linkHide.forEach(function (item, index) {
				item.addEventListener('mouseout',insertHTMLFadeOut);
			});


		}	

		function insertHTMLFadeOut() {

			showBlock.classList.remove('fadeIn');
			showBlock.classList.add('fadeOut');
			
			function hideTimeout() {
				showBlock.classList.add('hide');
			}

			/*задержка удаления блока, чтобы успела сработать анимация*/
			setTimeout(hideTimeout, 450);

			link.forEach(function (item, index) {
				item.addEventListener('mouseover',insertHTMLFadeIn);
			});

		}

		link.forEach(function (item, index) {
			item.addEventListener('mouseover',insertHTMLFadeIn);
		});
	}	
}
export default showAndHidePartFace;